<template>
    <footer class="background">
      <SocialIcons />
      <div class="rights">
        <p class="rights-text" v-text="`© ${getCurrentYear()} ${$t('contact.rights')}`"></p>
      </div>
    </footer>

</template>
<script setup>
import SocialIcons from "@/components/Helpers/SocialIcons.vue"

function getCurrentYear() {
  return new Date().getUTCFullYear();
}
</script>

<style scoped>

.background{
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -10px;
  margin-top: -40px;
}

.rights-text {
  font-family: 'Poppins-Regular';
  color: white;
  font-size: 20px;
  margin-top: -15px;

}

.rights {
  display: flex;
  justify-content: center;
}
</style>